<script setup lang="ts">
defineProps<{
  text?: string
}>()
</script>

<template>
  <div
    data-slot="chart-title"
    class="mx-auto w-full max-w-full p-2 text-center font-mono text-mono-xs font-medium text-chart-label"
  >
    <slot>
      {{ text }}
    </slot>
  </div>
</template>
